import React from "react";
import { BsFillBagFill, BsFillBasketFill, BsFillBasket2Fill, BsFillBasket3Fill } from "react-icons/bs";

const statusColors = {
  Pending: "bg-yellow-100 text-yellow-800",
  Accepted: "bg-blue-100 text-blue-800",
  "In Transit": "bg-purple-100 text-purple-800",
  Delivered: "bg-green-100 text-green-800",
  Cancelled: "bg-red-100 text-red-800",
}

const statusOrder = ["Pending", "Accepted", "In Transit", "Delivered"]

const OrderInfo = ({ order, handleStatusChange }) => {
  const calculateTotalTime = () => {
    const createdAt = new Date(order.createdAt)
    const updatedAt = new Date(order.updatedAt)
    const diffTime = Math.abs(updatedAt - createdAt)
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60))
    return `${diffDays}d ${diffHours}h ${diffMinutes}m`
  }

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <BsFillBagFill size={30} color="crimson" />
          <h1 className="pl-3 text-2xl font-semibold text-gray-800">Order Details</h1>
        </div>
        <div className="flex items-center">        
          {/* <span className={`px-3 py-1 rounded-full text-sm font-semibold ${statusColors[order.status]} mr-4`}>
            {order.status}
          </span> */}
          {/* <select
            className="form-select text-sm border-gray-300 rounded-md focus:ring-cyan-500 focus:border-cyan-500"
            value={order.status}
            onChange={(e) => handleStatusChange(e.target.value)}
          >
            {statusOrder.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
            <option value="Cancelled">Cancelled</option>
          </select> */}
        </div>
      </div>
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          {statusOrder.map((step, index) => (
            <div key={step} className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full ${
                  statusOrder.indexOf(order.status) >= index ? "bg-cyan-500" : "bg-gray-300"
                } flex items-center justify-center text-white text-sm font-bold`}
              >
                {index + 1}
              </div>
              <span className="text-xs mt-1">{step}</span>
            </div>
          ))}
        </div>
        <div className="relative pt-1">
          <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200">
            <div
              style={{ width: `${(statusOrder.indexOf(order.status) / (statusOrder.length - 1)) * 100}%` }}
              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-cyan-500"
            ></div>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-6">Total Time: {calculateTotalTime()}</p>
      
    </>
  )
}

export default OrderInfo

